import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=7b4d2094"
import script from "./Light.vue?vue&type=script&lang=js"
export * from "./Light.vue?vue&type=script&lang=js"
import style0 from "./Light.vue?vue&type=style&index=0&id=7b4d2094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports